/**
 * Ultra-simple PDF generator using jsPDF
 */
export const generatePDF = (markdownContent) => {
  // Use the browser's built-in print functionality
  const printWindow = window.open('', '_blank');
  
  if (!printWindow) {
    alert('Please allow pop-ups to download the PDF');
    return;
  }
  
  // Replace the contact information
  markdownContent = markdownContent.replace(
    "proposals@foxriverai.com | (555) 123-4567",
    "info@relufox.ai | (630) 940-8837"
  );
  
  // Replace any other instances of foxriver.ai with relufox.ai
  markdownContent = markdownContent.replace(/foxriver\.ai/g, "relufox.ai");
  
  // Convert markdown to simple HTML
  let htmlContent = markdownContent
    // Convert headers
    .replace(/^# (.*$)/gm, '<h1>$1</h1>')
    .replace(/^## (.*$)/gm, '<h2>$1</h2>')
    .replace(/^### (.*$)/gm, '<h3>$1</h3>')
    // Convert bold text
    .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
    // Convert bullet lists
    .replace(/^- (.*$)/gm, '<li>$1</li>')
    // Convert numbered lists
    .replace(/^\d+\. (.*$)/gm, '<li>$1</li>')
    // Convert paragraphs
    .replace(/^(?!<[hl]|<li)(.*$)/gm, '<p>$1</p>')
    // Remove image markdown
    .replace(/!\[.*?\]\(.*?\)/g, '');
  
  // Wrap lists in ul/ol tags
  htmlContent = htmlContent.replace(/<li>.*?<\/li>/g, match => {
    return '<ul>' + match + '</ul>';
  });
  
  // Write the HTML content to the new window
  printWindow.document.write(`
    <!DOCTYPE html>
    <html>
    <head>
      <title>Relufox AI Project Proposal</title>
      <style>
        body {
          font-family: Arial, sans-serif;
          line-height: 1.6;
          color: #333;
          max-width: 800px;
          margin: 0 auto;
          padding: 20px;
        }
        .header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 20px;
          border-bottom: 1px solid #ddd;
          padding-bottom: 10px;
        }
        .logo {
          height: 40px;
        }
        .title {
          text-align: right;
        }
        h1 {
          font-size: 22px;
          margin-top: 25px;
          margin-bottom: 15px;
        }
        h2 {
          font-size: 18px;
          margin-top: 20px;
          margin-bottom: 12px;
          border-bottom: 1px solid #eee;
          padding-bottom: 5px;
        }
        h3 {
          font-size: 15px;
          margin-top: 15px;
          margin-bottom: 10px;
        }
        p {
          margin-bottom: 12px;
        }
        ul, ol {
          margin-bottom: 15px;
          padding-left: 20px;
        }
        li {
          margin-bottom: 5px;
        }
        .footer {
          margin-top: 30px;
          font-size: 10px;
          color: #666;
          text-align: center;
          border-top: 1px solid #eee;
          padding-top: 10px;
        }
        @media print {
          body {
            padding: 0;
            margin: 15mm;
          }
          .no-break {
            page-break-inside: avoid;
          }
        }
      </style>
    </head>
    <body>
      <div class="header">
        <img src="/Fox-logo-1.png" alt="Relufox AI Logo" class="logo" />
        <div class="title">
          <div style="font-weight: bold; font-size: 16px;">Project Proposal</div>
          <div>${new Date().toLocaleDateString()}</div>
        </div>
      </div>
      
      <div class="content">
        ${htmlContent}
      </div>
      
      <div class="footer">
        © ${new Date().getFullYear()} Relufox AI | info@relufox.ai | (630) 940-8837
      </div>
      
      <script>
        // Add no-break class to important sections
        document.querySelectorAll('h2').forEach(heading => {
          if (heading.textContent.includes('Solution Architecture') || 
              heading.textContent.includes('Project Overview')) {
            const section = document.createElement('div');
            section.className = 'no-break';
            heading.parentNode.insertBefore(section, heading);
            
            // Move heading into section
            section.appendChild(heading);
            
            // Move next elements into section
            let nextElement = section.nextSibling;
            while (nextElement && 
                  (nextElement.tagName === 'P' || 
                   nextElement.tagName === 'UL' || 
                   nextElement.tagName === 'OL')) {
              const current = nextElement;
              nextElement = nextElement.nextSibling;
              section.appendChild(current);
            }
          }
        });
        
        // Print after a short delay to ensure images are loaded
        setTimeout(() => {
          window.print();
          // Close the window after printing (or if print is cancelled)
          setTimeout(() => {
            window.close();
          }, 1000);
        }, 1000);
      </script>
    </body>
    </html>
  `);
  
  printWindow.document.close();
};